<template>
  <div class="my-dropdown" :class="isOpen ? 'isOpen': ''">
    <div class="selected" @click="toggle">{{ currentLocale.label }}</div>
    <div class="options" v-show="isOpen">
      <div 
        class="option" 
        :class="$i18n.locale == option.value ? 'active' : ''" 
        v-for="option in options" 
        @click="set(option)" 
        :key="option.value" 
      >
        {{ option.label }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Dropdown",
  components: {},
  data: function() {
    return {
      isOpen: false,
      options: [  
        { value: 'it', label: 'IT' },
        { value: 'en', label: 'EN' },
        { value: 'cn', label: "中文" }
      ]
    }
  },
  computed: {
    currentLocale () {
      return this.options.find((locale) => locale.value == this.$i18n.locale)
    }
  },
  methods: {
    toggle: function() {
      this.isOpen = !this.isOpen;
    },
    show: function() {
      this.isOpen = true;
    },
    hide: function() {
      this.isOpen = false;
    },
    set: function(option) {
      this.$i18n.locale = option.value
      this.hide();
    }
  }
}
</script>